import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const ClinicalInvestigation = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Clinical Investigation ', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Clinical Investigation" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
<section class="service-details section-space">
    <div class="container">
        <div class="row flex-xl-row flex-column-reverse">
            <div class="col-xl-4">
                <div class="sidebar sidebar-rr-sticky">
                    <div class="sidebar__widget-service mb-30">
                        <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
                        <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i> </Link>
                        <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>
                    </div>
                    <div class="sidebar__widget-contact__service text-center">
                        <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
                        <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>
                        <Link to="/contact-us#" class="rr-btn">
                            <span class="btn-wrap">
                                <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="service-details__content">
                    <div class="service-details__content-media mb-20">
                        <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="img not found"/>
                    </div>
                    <h3 class="title-animation mb-10">Clinical Investigation</h3>
                    <p class="mb-20">Clinical investigation involves systematically studying new medical treatments, devices, or interventions to assess their safety, efficacy, and performance. It includes rigorous protocols, patient recruitment, data collection, and analysis to ensure reliable results while maintaining regulatory compliance and ethical considerations.</p>
                    
                    <h3 class="title-animation mb-10">Our Expertise in Clinical Investigation</h3>
                    <p class="mb-30">SQUARE MEDTECH provides high-quality assistance in planning, preparation, and execution of clinical investigations while ensuring compliance with regulatory requirements.</p>
                    <ul class="mb-40">
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Clinical Investigation Planning</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Clinical Investigation Project Management</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Regulatory Submissions</h5></li>
                    </ul>
                    
                    <h3 class="title-animation mb-10">How SQUARE MEDTECH Can Support in Clinical Investigation</h3>
                    <ul class="mb-40">
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Biostatistics</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Site Selection</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Site Monitoring</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Site Management</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Data Protection</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>General Data Management</h5></li>
                    </ul>
                    
                    <div class="row">
                        <div class="col-lg-7">
                            <div class="service-details__content-media-item service-details__content-media-item-1">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-2.jpg" class="img-fluid" alt="img not found"/>
                                </div>
                                <h4 class="title-animation mb-15">Data Management Consultancy</h4>
                                <p>SQUARE MEDTECH Data Management Consultancy optimizes data collection, integration, and analysis processes to ensure accurate and compliant insights.</p>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="service-details__content-media-item service-details__content-media-item-2">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-3.jpg" class="img-fluid" alt="img not found"/>
                                </div>
                                <h4 class="title-animation mb-15">Our Expertise in Healthcare Providers</h4>
                                <p>SQUARE MEDTECH provides regulatory expertise and specialized healthcare solutions, ensuring seamless project support for healthcare providers.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Medical Writing Services</h4>
                    <ul class="color-white mb-0">
                        <li>Investigator site file</li>
                        <li>CRFs & Questionnaires</li>
                        <li>Clinical investigation plan</li>
                    </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Medical Writing Services</h4>
                    <ul class="color-white mb-0">
                        <li>Safety documents</li>
                        <li>Registration of clinical studies</li>
                        <li>Literature search & Publications</li>
                    </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
